import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import EyeOpenIcon from '~/components/SVG/SvgEyes/EyeOpen.svg?react';

interface SvgEyeOpenProps {
  isActive?: boolean;
  isDocumentsPage?: boolean;
}

const getStrokeColor = (isActive = false, isDocumentsPage = false) => {
  if (!isDocumentsPage) return 'text.primary';
  return isActive ? 'primary.main' : 'grey.additionalGrey';
};

const styles = {
  icon:
    (isActive = false, isDocumentsPage = false) =>
    (theme: Theme) => ({
      width: '25px',
      height: '25px',
      color: getStrokeColor(isActive, isDocumentsPage),
      [theme.breakpoints.down('sm')]: {
        width: '15px',
        height: '15px',
      },
    }),
};

const SvgEyeOpen = ({ isActive, isDocumentsPage }: SvgEyeOpenProps) => {
  return <Box component={EyeOpenIcon} sx={styles.icon(isActive, isDocumentsPage)} />;
};

export default SvgEyeOpen;
